module.exports = __webpack_public_path__ + "static/media/driver-step-icon-fc.8f60c5c7.svg";